exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Checkout_unusualCheckout__tvVcm{margin-bottom:15px!important;font-size:14px!important}.Checkout_unusualCheckout__tvVcm:hover{text-decoration:none!important}.Checkout_standartCheckout__1zPTC{margin-bottom:15px;color:#333;font-size:12px;text-align:center}", "", {"version":3,"sources":["/apps/jenkins_26112018/jenkins/workspace/migrationBuildUiJob_actual/ui-prototypes/miniCartReminder/src/components/Checkout/index.scss"],"names":[],"mappings":"AAIA,iCACI,6BACA,wBAA0B,CAF9B,uCAIQ,8BAAgC,CAIxC,kCACI,mBACA,WACA,eACA,iBAAkB,CAAA","file":"index.scss","sourcesContent":["@import '../../styles/scss/variables';\n@import '../../styles/scss/colors';\n@import '../../styles/scss/_breakpoints';\n\n.unusualCheckout {//TODO: fix this !important\n    margin-bottom: 15px !important;\n    font-size: 14px !important;\n    &:hover {\n        text-decoration: none !important;\n    }\n}\n\n.standartCheckout {\n    margin-bottom: 15px;\n    color: $textBlack;\n    font-size: 12px;\n    text-align: center;\n}\n\n.link {\n    /* placeholder for styles */\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"fontStack": "\"Open Sans\",\"Lucida Grande\",Lucida,\"Lucida Sans Unicode\",sans-serif",
	"containerWidthMain": "960",
	"heightDesktopHeader": "139px",
	"minicartWidth": "350px",
	"minicartTipRightOffsetDesktop": "15px",
	"minicartTipSide": "5px",
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009b29",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"unusualCheckout": "Checkout_unusualCheckout__tvVcm",
	"standartCheckout": "Checkout_standartCheckout__1zPTC"
};